export default "__VITE_ASSET__bD5zuki$__"